import {Routes} from '@angular/router';
import {AuthGuard} from 'amc-common-components';
import {CtsDistributionGuard} from '@shared/services/cts-distribution.guard';

/**
 * Defines the application routes.
 * The routes array contains a route configuration objects.
 * @type {Routes}
 */
export const CtsDistributionRoutes: Routes = [
	{
		path: 'cts-distribution',
		canActivate: [AuthGuard, CtsDistributionGuard],
		loadChildren: () => import('./cts-distribution.module').then((m) => m.CtsDistributionModule),
	},
];

/**
 * Defines the application routes.
 * The routes array contains a route configuration objects.
 * @type {Routes}
 */
export const CtsDistributionFiltersRoutes: Routes = [
	{
		path: 'cts-distribution',
		canActivate: [AuthGuard, CtsDistributionGuard],
		loadChildren: () =>
			import('./cts-distribution-filters/cts-distribution-filters.module').then(
				(m) => m.CtsDistributionFiltersModule
			),
		outlet: 'filters',
	},
];
